"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATION_TYPES = exports.FIELD_TYPES = void 0;
const FIELD_TYPES = ["text", "select", "textarea", "radio", "checkbox", "upload"];
exports.FIELD_TYPES = FIELD_TYPES;
const VALIDATION_TYPES = ["string", "number", "boolean", "date", "array", "object"];
exports.VALIDATION_TYPES = VALIDATION_TYPES;